import { TokenAPI } from '../api/token/tokenApi';
import { Token } from '../api';

/**
 * Class created for handling authentication and session management
 */
export class Auth {
  public readonly clientId: string;
  private clientSecret: string;
  private token: Token;
  private tokenApi = new TokenAPI();

  constructor(clientId: string, clientSecret?: string) {
    this.clientId = clientId;
    this.clientSecret = clientSecret;
  }

  async authenticate() {
    await this.tokenApi.getToken(this.clientId);
    return this;
  }

  async getToken() {
    if (!this.token || this.isTokenExpired(this.token)) {
      this.token = await this.tokenApi.getToken(this.clientId);
    }

    return this.token;
  }

  protected isTokenExpired(token: Token): boolean {
    return !token || Math.floor(Date.now() / 1000) > token.createdAt + token.expiresIn;
  }
}
